import { createActionGroup, props } from '@ngrx/store';
import { MosCommand, ServerMosCommand } from '@src/suite/common/store/mos/models/mos.models';

export const MosActions = createActionGroup({
    source: 'MosCommand',
    events: {
        'Mos Server command send': props<ServerMosCommand>(),
        'Mos Client command send': props<MosCommand>(),
    },
});
